import { render, staticRenderFns } from "./QueryTheFirstPlayerOfCostXYuanDialog.vue?vue&type=template&id=3972d113"
import script from "./QueryTheFirstPlayerOfCostXYuanDialog.vue?vue&type=script&lang=js"
export * from "./QueryTheFirstPlayerOfCostXYuanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports